import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceStatus as _DeviceStatus } from 'shared/models';

export const getDeviceStatusTextKey = (status: string | null): string => {
    switch (status) {
        case _DeviceStatus.Up:
            return 'DEVICES.STATUS.UP';
        case _DeviceStatus.Late1:
            return 'DEVICES.STATUS.LATE1';
        case _DeviceStatus.Late2:
            return 'DEVICES.STATUS.LATE2';
        case _DeviceStatus.Down:
            return 'DEVICES.STATUS.DOWN';
        case _DeviceStatus.Offline:
            return 'DEVICES.STATUS.OFFLINE';
        default:
            return 'DEVICES.STATUS.UNKNOWN';
    }
};

const getDeviceStatusIcon = (status: string | null): string => {
    switch (status) {
        case _DeviceStatus.Up:
            return 'green check circle';
        case _DeviceStatus.Late1:
            return 'yellow warning';
        case _DeviceStatus.Late2:
            return 'yellow warning circle';
        case _DeviceStatus.Down:
            return 'red remove circle';
        case _DeviceStatus.Offline:
            return 'grey minus';
        default:
            return 'grey help circle';
    }
};

export const DeviceStatus = ({ status, showLabel = false }: { status: string | null; showLabel?: boolean }) => {
    const { t } = useTranslation();
    const label = t(getDeviceStatusTextKey(status));
    return (
        <span>
            <i
                className={ `${getDeviceStatusIcon(status)} icon` }
                title={ label }
            />
            { showLabel &&
                <span>
                    { label }
                </span>
            }
        </span>
    );
};
